import { NgModule } from '@angular/core';
import { StateSrefLinkDirective } from './state-sref-link.directive';
import { StateSrefButtonDirective } from './state-sref-button.directive';

@NgModule({
    declarations: [StateSrefLinkDirective, StateSrefButtonDirective],
    exports: [StateSrefLinkDirective, StateSrefButtonDirective],
})
export class FiStateSrefModule {}
